import styled from "styled-components";
import { Tag } from "./Tag";
import { handleFormatDate } from "../../../../utilits";
import { useGetSourcesQuery } from "../../../../store/objects/objects.api";

export const Footer = ({
  createDate,
  dateEdit,
  data,
  id,
  idSource,
  nameSource,
  typeObject,
  dateDelete,
}) => {
  const { data: sources } = useGetSourcesQuery();

  const format = (date) =>
    date && date !== "0" ? handleFormatDate(Number(date) * 1000) : "-";

  // ---------- 1. На ресурсі ----------
  const sourceAdd = format(data.dt_add_in_source);
  const sourceEdit = format(data.dt_edit_in_source);
  const sourceLabel = `Додано/Оновлено на ресурсі ${sourceAdd} / ${sourceEdit}`;

  // ---------- 2. В системі ----------
  const systemAdd = format(data.dt_add);
  const systemEdit = format(data.dt_edit);
  const systemLabel = `Додано/Оновлено в системі ${systemAdd} / ${systemEdit}`;

  return (
    <StyledFooter className="flex flex-wrap items-center clickable">
      {/* ID */}
      {id ? (
        <Tag
          title={`ID ${typeObject === "street_base" ? "Системи" : ""}`}
          copyValue={id}
          isCopy
        />
      ) : null}

      {/* ID на ресурсі + назва ресурсу */}
      {idSource !== "0" && typeObject !== "company" ? (
        <>
          <Tag title="ID на ресурсі" copyValue={idSource} isCopy />
          {sources?.[nameSource]?.length > 0 ? (
            <Tag title={sources?.[nameSource] ?? ""} />
          ) : null}
        </>
      ) : null}

      {/* Тег 1 – на ресурсі */}
      <Tag title={sourceLabel} />

      {/* Тег 2 – в системі */}
      <Tag title={systemLabel} />
    </StyledFooter>
  );
};

const StyledFooter = styled.div`
  gap: 3px;
`;
